//  Copyright (c) 2018 First Foundry Inc. All rights reserved.

export const PATH = 'transactionHistoryReports'
export const OPEN_TRANSACTION_REPORT_LIST = `${PATH}/OPEN_TRANSACTION_REPORT_LIST `
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const SET_TRANSACTION_DATA = `${PATH}/SET_TRANSACTION_DATA`
export const SET_SORT = `${PATH}/SET_SORT `
export const SET_PAGE = `${PATH}/SET_PAGE`
export const SET_SEARCH_TERM = `${PATH}/SET_SEARCH_TERM`
export const SET_RESULT = `${PATH}/SET_RESULT`
export const SET_NEXT_RECEIPT = `${PATH}/SET_NEXT_RECEIPT`
export const SET_PREVIOUS_RECEIPT = `${PATH}/SET_PREVIOUS_RECEIPT`
